const { Logger } = require('@vue-storefront/core');
const getPersonalizedDiscountsQuery = require('../queries/cart/getPersonalizedDiscountsQuery');
const { clientQuery } = require('./queries');

/**
 * @param {import('@nuxt/types').Context} context
 * @param {{ discountGroup: StringConstructor }} params
 */

module.exports.getPersonalizedDiscounts = async (context, { cohortTier }) => {
  const { store } = context.config;
  if (!store || !cohortTier) {
    return;
  }

  try {
    const discountResponse = await clientQuery(context, {
      query: getPersonalizedDiscountsQuery,
      variables: {
        key: cohortTier,
        cohortTier,
      },
    });
    // make sure at least one of the stores' key matches the current store
    const isStoreValid = discountResponse?.data?.cartDiscount?.storesRef?.some(
      (storeRef) => storeRef.key === context.config.store,
    );
    const canCustomerGetPersonalizedDiscount = isStoreValid && discountResponse?.data?.cartDiscount?.isActive;
    return canCustomerGetPersonalizedDiscount ? discountResponse : null;
  } catch (e) {
    Logger.error(e);
  }
};
